import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Rating,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { StarRounded } from "@mui/icons-material";
import moment from "moment";
import {
  arrowBgColor,
  backgroundColor02,
  blackColor,
  blackColor26,
  blackColor27,
  greyColor9,
  headingColor,
  orangeColor01,
  reviewBodyColor,
  reviewCardBorderColor,
  reviewSubColor,
  whiteColor,
} from "../../configs/styles/muiThemes";
import UserCharAvatar from "./UserCharAvatar";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import SingleStarRatingDisplay from "./SingleStarRatingDisplay";

// Card for review contnets display
function ReviewCard(props) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const contentLength = matches ? 130 : 90;

  return matches ? (
    <Box
      sx={{
        p: "15px",
        textAlign: "left",
        borderRadius: "10px",
        border: "1px solid " + reviewCardBorderColor,
        backgroundColor: whiteColor,
        height: "100%",
      }}
    >
      <Box display={"flex"} justifyContent={"space-between"} gap={1}>
        <Box display={"flex"} gap={1}>
          {props?.images?.[0]?.photoUrl ? (
            <Avatar
              sx={{
                width: { md: 40, xs: "38px" },
                height: { md: 40, xs: "38px" },
              }}
              alt="customer profile"
              src={
                props?.showFullData
                  ? props?.data?.profilePic
                  : props?.images?.[0]?.photoUrl
                  ? props?.images?.[0]?.photoUrl
                  : "https://storage.googleapis.com/bodefaults/shopweb/reviews/review-user.svg"
              }
            />
          ) : (
            <UserCharAvatar
              username={props.data.name}
              imgwidth="38px"
              imgheight="38px"
            />
          )}

          <Box>
            <Typography
              variant="body1"
              fontSize={13}
              fontWeight={600}
              color={blackColor}
              lineHeight="22px"
            >
              {props.data.name}
            </Typography>
            <Typography
              variant="body1"
              fontSize={11.5}
              fontWeight={400}
              lineHeight="16px"
              color={greyColor9}
            >
              {`${props.totalReviews} Reviews | ${props.connection} Connections`}
            </Typography>
          </Box>
        </Box>
        <Box display={"flex"} flexDirection={"column"} alignItems={"flex-end"}>
          <Typography
            variant="body1"
            fontSize={12}
            fontWeight={500}
            lineHeight="16px"
            color={greyColor9}
          >
            {moment(props.data.updateDate).format("MMM DD, YYYY")}
          </Typography>

          <Box display="flex" alignItems="flex-end" gap="3px" mt={0.3}>
            <Typography
              variant="body1"
              fontSize={12}
              fontWeight={600}
              lineHeight="16px"
              color={blackColor}
            >
              {props.data.reviewRating}{" "}
            </Typography>

            {/* <StarRoundedIcon
              sx={{
                width: "18.5px",
                height: "18.5px",
                color: orangeColor01,
              }}
            /> */}
            <SingleStarRatingDisplay rating={props.data.reviewRating} />
          </Box>

          {/* <Rating
            readOnly
            icon={
              <Box
                component="img"
                src={`https://storage.googleapis.com/bodefaults/shopweb/reviews/star.svg`}
                alt={`Star`}
                sx={{
                  width: "12x",
                  height: "12px",
                  display: "flex",
                  lineHeight: 1.5,
                  mr: "2px",
                }}
              />
            }
            emptyIcon={
              <Box
                component="img"
                src={`https://storage.googleapis.com/bodefaults/shopweb/reviews/star-1.svg`}
                alt={`Star`}
                sx={{
                  width: "12x",
                  height: "12px",
                  display: "flex",
                  lineHeight: 1.5,
                }}
              />
            }
            precision={0.1}
            value={props.data.reviewRating}
            sx={{ marginBottom: 1 }}
          /> */}
        </Box>
      </Box>

      <Box
        sx={{
          textAlign: "left",
          mt: "12px",
        }}
      >
        <Typography
          variant="h5"
          fontSize={13}
          fontWeight={500}
          lineHeight="20px"
          color={blackColor}
        >
          {props.data.reviewTitle}
        </Typography>

        <Typography
          variant="body1"
          color={greyColor9}
          sx={{
            height: props.isShownInModal ? "auto" : "40px",
            overflow: props.isShownInModal ? "none" : "hidden",
          }}
          fontSize={{ md: "12.5px", xs: "12px" }}
          lineHeight="19px"
          mt="5px !important"
        >
          {props.isShownInModal && props.showFullData ? (
            props.data.message
          ) : (
            <Typography
              variant="body1"
              color={greyColor9}
              sx={{
                height: props.isShownInModal ? "auto" : "40px",
                overflow: props.isShownInModal ? "none" : "hidden",
              }}
              fontSize={{ md: "12.5px", xs: "12px" }}
              lineHeight="19px"
            >
              {props.data.message.slice(0, contentLength)}{" "}
              {props.data.message.length > contentLength ? (
                <span
                  onClick={() =>
                    props.onClickMore({
                      data: props.data,
                      totalReviews: props.totalReviews,
                      connection: props.connection,
                    })
                  }
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    textDecoration: "underline",
                    color: orangeColor01,
                    pl: 1,
                  }}
                >
                  Click More
                </span>
              ) : null}
            </Typography>
          )}
        </Typography>
      </Box>
    </Box>
  ) : (
    <Box
      sx={{
        p: "12px",
        textAlign: "left",
        borderRadius: "10px",
        border: "1px solid " + reviewCardBorderColor,
        backgroundColor: props.isShownInModal ? whiteColor : backgroundColor02,
      }}
    >
      <Box display={"flex"} justifyContent={"space-between"} gap={1}>
        <Box display={"flex"} gap={1}>
          {props?.images?.[0]?.photoUrl ? (
            <Avatar
              sx={{
                width: { md: 50, xs: "34px" },
                height: { md: 50, xs: "34px" },
              }}
              alt="customer profile"
              src={
                props?.showFullData
                  ? props?.data?.profilePic
                  : props?.images?.[0]?.photoUrl
                  ? props?.images?.[0]?.photoUrl
                  : "https://storage.googleapis.com/bodefaults/shopweb/reviews/review-user.svg"
              }
            />
          ) : (
            <UserCharAvatar
              username={props.data.name}
              imgwidth="34px"
              imgheight="34px"
            />
          )}

          <Box>
            <Typography
              variant="body1"
              fontSize={12}
              fontWeight={600}
              color={blackColor27}
              lineHeight="22px"
            >
              {props.data.name}
            </Typography>
            <Typography
              variant="body1"
              fontSize={11}
              fontWeight={400}
              lineHeight="16px"
              color={blackColor26}
            >
              {`${props.totalReviews} Reviews | ${props.connection} Connections`}
            </Typography>
          </Box>
        </Box>
        <Box display={"flex"} flexDirection={"column"} alignItems={"flex-end"}>
          <Typography
            variant="body1"
            fontSize={11}
            fontWeight={400}
            lineHeight="20px"
            color={blackColor26}
          >
            {moment(props.data.updateDate).format("MMM DD, YYYY")}
          </Typography>
          <Box display="flex" alignItems="flex-end" gap="3px">
            <Typography
              variant="body1"
              fontSize={11}
              fontWeight={600}
              lineHeight="16px"
              color={blackColor26}
            >
              {props.data.reviewRating}{" "}
            </Typography>

            <SingleStarRatingDisplay rating={props.data.reviewRating} />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          textAlign: "left",
          mt: "4px",
        }}
      >
        <Typography
          variant="h5"
          fontSize={11.5}
          fontWeight={500}
          lineHeight="20px"
          color={blackColor27}
        >
          {props.data.reviewTitle}
        </Typography>

        <Typography
          variant="body1"
          color={blackColor26}
          sx={{
            height: props.isShownInModal ? "auto" : "34px",
            overflow: props.isShownInModal ? "none" : "hidden",
          }}
          fontSize={{ md: "13px", xs: "11px" }}
          lineHeight="17px"
          // mt="5px !important"
        >
          {props.isShownInModal && props.showFullData ? (
            props.data.message
          ) : (
            <Typography
              variant="body1"
              color={reviewBodyColor}
              sx={{
                height: props.isShownInModal ? "auto" : "34px",
                overflow: props.isShownInModal ? "none" : "hidden",
              }}
              fontSize={{ md: "13px", xs: "12px" }}
              lineHeight="17px"
            >
              {props.data.message.slice(0, contentLength)}{" "}
              {props.data.message.length > contentLength ? (
                <span
                  onClick={() =>
                    props.onClickMore({
                      data: props.data,
                      totalReviews: props.totalReviews,
                      connection: props.connection,
                    })
                  }
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    textDecoration: "underline",
                    color: orangeColor01,
                    pl: 1,
                  }}
                >
                  Click More
                </span>
              ) : null}
            </Typography>
          )}
        </Typography>
      </Box>
    </Box>
  );
}

export default ReviewCard;

const cardStyles = {
  headerTitle: {
    fontSize: { md: "15px", xs: "14px" },
    color: headingColor,
    fontWeight: 600,
  },

  headerSub: {
    fontSize: "13px",
    fontWeight: 400,
    color: reviewSubColor,
    marginTop: "4px",
  },

  actionBtn: {
    fontSize: "14px",
    fontWeight: 400,
    textTransform: "none",
    "&:hover": {
      backgroundColor: whiteColor,
    },
  },
};
